import React from 'react';
export function StickyBar() {
  return <div className="fixed top-0 left-0 w-full bg-orange text-white z-50 py-3 px-4 shadow-md" data-id="element-143">
      <div className="max-w-6xl mx-auto text-center" data-id="element-144">
        <p className="font-body font-bold text-sm md:text-base flex items-center justify-center gap-2" data-id="element-145">
          <span className="text-lg" data-id="element-146">🔥</span>
          <span data-id="element-147">
            ACESSO IMEDIATO: Garanta o método completo por apenas R$ 34,90.
            Oferta por tempo limitado.
          </span>
        </p>
      </div>
    </div>;
}